<app-smartsupp [username]="smartsuppUsername" [name]="localUser.name"></app-smartsupp>

<div class="container">

  <div class="form-signin">
    <div style="float: right;">
      <a href="{{classroom.newStudentPortalUrl}}student-portal/login?target={{window.location.origin}}/{{classroom.roomNum}}">Staff login</a>
    </div>
    <h4>Hello!</h4>
    <p *ngIf="selectedClassId">Oops... it seems there is another class in session. Please check your schedule.</p>
    <p *ngIf="!selectedClassId">Your class has not started yet. Please <a href="javascript:void(0)" (click)="tryAgain()">try again</a> later.</p>
    <p><a [href]="currentClassSpUrl || classroom.newStudentPortalUrl">Go back to Student Portal</a></p>
    <br/>
  </div>
</div>
